import { ScheduledScreen } from '@shared/types';

export type ScheduleState = {
  schedule: Array<ScheduledScreen>
  current?: ScheduledScreen;
  error?: string;
  isBusy: boolean;
}

export const schedule: ScheduleState = {
  schedule: [],
  current: undefined,
  isBusy: false,
  error: undefined
};
